var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 49,
    viewBox: "0 0 67 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1839_3255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.368 6.59505V21.4093C30.368 23.3056 28.8683 24.9211 26.9721 24.9312C26.0239 24.9356 25.1626 24.552 24.5402 23.9324C23.925 23.3143 23.5414 22.4602 23.5414 21.5179V8.51161C23.5414 7.57939 22.7857 6.82521 21.8549 6.82521H3.52169C1.62539 6.82521 0.00992522 5.32555 -0.000207655 3.42925C-0.00455031 2.48111 0.379051 1.61981 0.998604 0.997364C1.61671 0.383602 2.47077 0 3.41312 0H23.7744C27.4165 0 30.3695 2.95301 30.3695 6.59505H30.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5801 4.79723C65.9533 2.68091 64.2829 1.01188 62.1622 0.389431C61.5774 0.217172 60.9607 0.125977 60.3195 0.125977H43.3122C42.6709 0.125977 42.0542 0.217172 41.4694 0.389431C39.3473 1.01333 37.6768 2.68091 37.0515 4.80013C36.8778 5.38783 36.7837 6.01028 36.7837 6.65444V18.2797C36.7837 18.9239 36.8778 19.5464 37.0515 20.1341C37.6768 22.2518 39.3473 23.9209 41.4694 24.5448C42.0542 24.717 42.6709 24.8082 43.3122 24.8082H60.3195C60.9607 24.8082 61.5774 24.717 62.1622 24.5448C64.2829 23.9209 65.9533 22.2533 66.5801 20.137C66.7538 19.5492 66.8479 18.9254 66.8479 18.2812V6.65299C66.8479 6.00883 66.7538 5.38494 66.5801 4.79723ZM58.4203 18.0496H45.2085C44.2864 18.0496 43.5394 17.3012 43.5394 16.3791V8.55363C43.5394 7.63154 44.2864 6.88315 45.2085 6.88315H58.4203C59.3424 6.88315 60.0907 7.63154 60.0907 8.55363V16.3791C60.0907 17.3012 59.3424 18.0496 58.4203 18.0496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1908 41.8609V32.1782C55.1908 30.2819 53.6911 28.6664 51.7948 28.6563C50.8467 28.6519 49.9854 29.0355 49.3629 29.6551C48.7477 30.2732 48.3641 31.1273 48.3641 32.0696V39.9443C48.3641 40.8765 47.6085 41.6307 46.6777 41.6307H27.3558C25.4595 41.6307 23.844 43.1304 23.8339 45.0267C23.8296 45.9748 24.2132 46.8361 24.8327 47.4586C25.4508 48.0738 26.3049 48.4574 27.2472 48.4574H48.5957C52.2378 48.4574 55.1908 45.5044 55.1908 41.8623V41.8609Z",
    fill: "url(#paint0_linear_1839_3255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9999 44.8307C66.9999 46.8327 65.3772 48.4554 63.3753 48.4554H63.2348C62.2346 48.4554 61.327 48.0486 60.6712 47.3943C60.0126 46.7343 59.6044 45.8194 59.6102 44.8119C59.6189 42.7998 61.3357 41.2061 63.3506 41.2061H63.3753C65.3772 41.2061 66.9999 42.8288 66.9999 44.8307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2249 11.9497V18.5781H3.31345C1.48374 18.5781 0 17.0943 0 15.2646C0 14.3483 0.370574 13.5203 0.971308 12.921C1.57204 12.3203 2.40004 11.9497 3.3149 11.9497H30.2249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3681 35.0526V44.9321C30.3681 46.8284 28.8685 48.4439 26.9722 48.454C26.024 48.4583 25.1627 48.0747 24.5403 47.4552C23.9251 46.8371 23.5415 45.983 23.5415 45.0407V36.9691C23.5415 36.0369 22.7858 35.2827 21.8551 35.2827H3.52181C1.62552 35.2827 0.0100473 33.7831 -8.55847e-05 31.8868C-0.00442824 30.9386 0.379173 30.0773 0.998726 29.4549C1.61683 28.8397 2.47089 28.4561 3.41324 28.4561H23.7745C27.4166 28.4561 30.3696 31.4091 30.3696 35.0511L30.3681 35.0526Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1839_3255",
    x1: 27.363,
    y1: 38.5561,
    x2: 55.1908,
    y2: 38.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0964486,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1839_3255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 48.4554,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.66464969214a267cdc837106de4b8b26.svg";
export { ForwardRef as ReactComponent };